<section class="cart-page" aria-labelledby="cart-title">
  <h1 id="cart-title" class="sr-only">{{ 'components.cart.title' | i18n }}</h1>

  <ng-container *ngIf="(combinedLoading$ | async); else content">
    <umkt-loading
      [isLoading]="true"
      [showText]="true"
      [text]="'components.cart.loading' | i18n"
      mode="contained">
    </umkt-loading>
  </ng-container>

  <ng-template #content>
    <ng-container *ngIf="(count$ | async) as count; else emptyState">
      <div *ngIf="count > 0" class="cart-layout">
        <div class="products-scroll">
          <umkt-cart-product-list
            [products]="(products$ | async) ?? []"
            (removePlan)="onRemovePlan($event)"
            (changeQty)="onChangeQty($event)"
            (undoRemove)="handleUndoRemove($event)">
          </umkt-cart-product-list>
        </div>

        <div class="infos-card">
          <div class="actions">
            <ustore-button
              class="custom-ustore-btn"
              [format]="'outlined'"
              [backgroundColor]="'var(--color-red-500-to-yellow)'"
              [size]="'medium'"
              [rounded]="'rounded'"
              [text]="'components.cart.actions.clearCart' | i18n"
              [icon]="{ name: 'bi bi-trash3', type: 'bootstrap-icons', position: 'left' }"
              (onClick)="openClearCartConfirm()">
            </ustore-button>
            
            <umkt-confirm-modal
              [open]="showClearConfirm"
              variant="danger"
              icon="bi bi-exclamation-triangle"
              [title]="'components.cart.modal.clearTitle' | i18n"
              [message]="'components.cart.modal.clearMessage' | i18n"
              (confirm)="handleClearConfirm()"
              (cancel)="handleClearCancelOrClose()"
              (closed)="handleClearCancelOrClose()"
              [confirmText]="'components.cart.actions.confirmClear' | i18n"
            ></umkt-confirm-modal>
          </div>
          <div class="infos-separate"></div>
          <section class="infos" aria-labelledby="infos-title">
            <h2 id="infos-title" class="sr-only">{{ 'components.cart.info.title' | i18n }}</h2> <dl class="infos__list">
              <div class="infos__row">
                <dt class="infos__label">{{ 'components.cart.info.installation' | i18n }}</dt>
                <dd class="infos__value">{{ 'components.cart.info.free' | i18n }}</dd>
              </div>

              <div class="infos__row">
                <dt class="infos__label">{{ 'components.cart.info.membership' | i18n }}</dt>
                <dd class="infos__value">{{ 'components.cart.info.free' | i18n }}</dd>
              </div>
            </dl>
          </section>
        </div>
      </div>
    </ng-container>

    <ng-template #emptyState>
      <div class="cart-empty" aria-label="Carrinho vazio"> 
        <div class="cart-empty__content">
          <div class="cart-empty__image">
              <img src="assets/images/cart.png" alt="Ilustração de carrinho vazio" />
          </div>
          <div class="cart-empty__message">
            <p class="cart-empty__title">{{ 'components.cart.empty.title' | i18n }}</p>
            <p class="cart-empty__description">
               {{ 'components.cart.empty.description' | i18n }}
            </p>
          </div>
        </div>
        <div class="cart-empty__products">
          <umkt-cart-product-list
              [products]="(mockCartProducts$ | async) ?? []"
              [isCartEmpty]="true"
              (removePlan)="onRemovePlan($event)"
              (changeQty)="onChangeQty($event)">
          </umkt-cart-product-list>
        </div>
      </div>
    </ng-template>
  </ng-template>
</section>